import { errorTextStyles as e, formHelperTextStyles as t, formLabelStyles as n, formRootStyles as r } from "../shared/form-primitives.js";
import { cva as i } from "class-variance-authority";
// src/design/forms/select/style.ts
var a = r, o = n, s = t, c = e, l = i("relative flex items-center", {
	variants: { disabled: {
		true: "cursor-not-allowed",
		false: ""
	} },
	defaultVariants: { disabled: !1 }
}), u = i([
	"flex",
	"items-center",
	"justify-between",
	"min-h-8",
	"w-full",
	"rounded-md",
	"border",
	"border-input-border",
	"bg-input-background",
	"px-2",
	"py-1",
	"text-sm",
	"transition-all",
	"duration-normal",
	"hover:bg-muted",
	"focus-visible:outline-hidden focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50",
	"disabled:cursor-not-allowed",
	"disabled:bg-muted",
	"disabled:opacity-60",
	"data-[state=open]:outline-hidden",
	"data-[state=open]:border-ring",
	"data-[state=open]:ring-3",
	"data-[state=open]:ring-ring/50",
	"data-[state=open]:bg-input-background"
], {
	variants: { invalid: {
		true: "border-destructive focus-visible:border-destructive focus-visible:ring-destructive/50 data-[state=open]:border-destructive data-[state=open]:ring-destructive/50",
		false: ""
	} },
	defaultVariants: { invalid: !1 }
}), d = i([
	"flex-1",
	"text-left",
	"text-sm",
	"leading-tight",
	"truncate"
], {
	variants: { hasValue: {
		true: "text-foreground",
		false: "text-muted-foreground/60 lowercase"
	} },
	defaultVariants: { hasValue: !1 }
}), f = i([
	"flex",
	"items-center",
	"justify-center",
	"ml-2",
	"shrink-0"
]), p = i([
	"flex",
	"items-center",
	"justify-center",
	"p-0.5",
	"rounded-sm",
	"text-muted-foreground",
	"hover:bg-muted",
	"hover:text-foreground",
	"transition-colors",
	"duration-normal",
	"cursor-pointer",
	"shrink-0"
]), m = i([
	"flex",
	"flex-1",
	"flex-wrap",
	"items-center",
	"gap-0.5",
	"min-w-0"
]), h = i([
	"inline-flex",
	"items-center",
	"gap-1",
	"rounded-md",
	"px-[4px]",
	"py-[2px]",
	"text-xs",
	"transition-colors",
	"duration-normal"
], {
	variants: { variant: {
		default: "bg-muted text-foreground border border-input-border",
		primary: "bg-secondary text-primary border border-secondary",
		success: "bg-success/10 text-success-text border border-success/30",
		warning: "bg-warning/10 text-warning-text border border-warning/30",
		danger: "bg-destructive/10 text-destructive border border-destructive/30"
	} },
	defaultVariants: { variant: "default" }
}), g = i("truncate max-w-[150px] leading-none"), _ = i([
	"inline-flex",
	"items-center",
	"justify-center",
	"w-4",
	"h-4",
	"rounded-sm",
	"p-0.5",
	"text-muted-foreground",
	"hover:bg-accent",
	"hover:text-foreground",
	"cursor-pointer",
	"transition-colors",
	"duration-normal"
]), v = i([]), y = i([
	"z-floating",
	"min-w-[var(--reference-width)]",
	"overflow-hidden",
	"rounded-md",
	"border",
	"border-input-border",
	"bg-menu-background",
	"shadow-[0px_1px_4px_0px_rgba(0,0,0,0.05)]",
	"animate-[fadeIn_0.15s_ease-in-out]",
	"transition-all",
	"duration-normal"
]), b = i([
	"max-h-[300px]",
	"overflow-y-auto",
	"overscroll-contain",
	"scroll-pb-1",
	"py-1"
]), x = i([
	"relative",
	"flex",
	"items-center",
	"gap-2",
	"px-2",
	"py-2",
	"border-b",
	"border-input-border"
]), S = i([
	"absolute",
	"left-4",
	"top-1/2",
	"-translate-y-1/2",
	"flex",
	"items-center",
	"justify-center",
	"text-muted-foreground",
	"pointer-events-none"
]), C = i([
	"h-8",
	"w-full",
	"rounded-md",
	"border",
	"border-input-border",
	"bg-input-background",
	"pl-8",
	"pr-2",
	"text-sm",
	"text-foreground",
	"placeholder:text-muted-foreground",
	"outline-hidden",
	"transition-colors",
	"duration-normal",
	"focus:border-ring",
	"focus:ring-3",
	"focus:ring-ring/50"
]), w = i([
	"px-3",
	"py-2",
	"text-sm",
	"text-muted-foreground",
	"text-center"
]), T = i(""), E = i([
	"px-3",
	"py-1.5",
	"text-xs",
	"font-semibold",
	"text-muted-foreground",
	"uppercase",
	"tracking-wide"
]), D = i([
	"flex",
	"items-center",
	"justify-between",
	"px-3",
	"py-2",
	"text-sm",
	"cursor-pointer",
	"outline-hidden",
	"transition-all",
	"duration-normal",
	"border-l-2",
	"border-l-transparent",
	"data-[highlighted]:bg-muted",
	"data-[highlighted]:border-l-primary",
	"data-[state=checked]:bg-secondary",
	"data-[state=checked]:text-primary",
	"data-[state=checked]:font-medium",
	"data-[disabled]:text-muted-foreground",
	"data-[disabled]:cursor-not-allowed",
	"data-[disabled]:hover:bg-transparent"
], {
	variants: { selected: {
		true: "text-primary font-medium bg-secondary",
		false: "text-foreground font-normal"
	} },
	defaultVariants: { selected: !1 }
}), O = i(["flex-1 truncate", "[&_mark]:bg-primary/20 [&_mark]:text-primary [&_mark]:rounded-sm [&_mark]:font-medium [&_mark]:not-italic"]), k = i(["ml-2", "text-primary"]), A = i("text-destructive"), j = () => ({
	root: a,
	label: o,
	control: l,
	trigger: u,
	valueText: d,
	indicator: f,
	clearTrigger: p,
	valueContainer: m,
	multiValue: h,
	multiValueLabel: g,
	multiValueRemove: _,
	positioner: v,
	content: y,
	list: b,
	searchWrapper: x,
	searchIconWrapper: S,
	searchInput: C,
	emptyState: w,
	itemGroup: T,
	itemGroupLabel: E,
	item: D,
	itemText: O,
	itemIndicator: k,
	helperText: s,
	errorText: c,
	requiredIndicator: A
});
export { p as clearTriggerStyles, y as contentStyles, l as controlStyles, w as emptyStateStyles, c as errorTextStyles, j as getStyles, s as helperTextStyles, f as indicatorStyles, E as itemGroupLabelStyles, T as itemGroupStyles, k as itemIndicatorStyles, D as itemStyles, O as itemTextStyles, o as labelStyles, b as listStyles, g as multiValueLabelStyles, _ as multiValueRemoveStyles, h as multiValueStyles, v as positionerStyles, A as requiredIndicatorStyles, a as rootStyles, S as searchIconWrapperStyles, C as searchInputStyles, x as searchWrapperStyles, u as triggerStyles, m as valueContainerStyles, d as valueTextStyles };

//# sourceMappingURL=style.js.map